import { InvoicePdfType } from "../../features/transactions/pay_day_view/pay-day-quick-view/models/invoice-display-model";

export class AppEndpoints {

  static transaction = {

    // Rollover Endpoints
    getMainIndustries: () =>
      `/Companies/industry-types`
    ,

    // Rollover Endpoints
    getRolloverPercentages: (companyId: number) =>
      `/RollOvers/percentages/company/${companyId}`
    ,

    getRolloverDays: (companyId: number) =>
      `/RollOvers/days/company/${companyId}`
    ,

    getRolloverViews: (companyId: number) =>
      `/RollOvers/company/${companyId}/history`,

    getInitialRolloverDataByCompanyAndSalaryCycle: (companyId: number, salaryCycleId: number) =>
      `/RollOvers/company/${companyId}/salary-cycle/${salaryCycleId}/initial-data`,

    calculateRolloverAmount: (payload: any) =>
      `/RollOvers/calculate-amount/comapnyId/${payload.companyId}/cutoffId/${payload.cutoffRecordId ?? 0}/totalRedAmnt/${payload.totalRedemptionAmount}/rrlpercentId/${payload.rollOverPercentageId}/rrldayId/${payload.rollOverDaysId}`,

    getRolloverDetails: (companyId: number, rolloverId: number) =>
      `/RollOvers/company/${companyId}/${rolloverId}`,

    getCompanyRolloverPaymentStatuses: (companyId: number, rolloverId: number) =>
      `/RollOvers/company-rollover-payment-statuses/${companyId}/${rolloverId}`,

    checkExistingRolloverRequest: (companyId: number, cutoffRecordId: number) => {
      const params = new URLSearchParams({
        companyId: companyId.toString(),
        cutoffRecordId: cutoffRecordId.toString()
      });
      return `/RollOvers/check-existing-rollover?${params.toString()}`
    },

    sendFroApprovalRolloverRequest: () =>
      `/RollOvers/requests`,

    payRollover: (payload: any) =>
      `/Transactions/company/${payload.companyId}/${payload.invoiceType}/${payload.invoiceContextId}/pay-now`,

    // Wage Withdrawals Endpoints
    getCompanyWageWithdrawalsSummery: (companyId: number) =>
      `/WageWithdrawals/companies/${companyId}/monthly`,

    getTotalWages: (companyId: number) =>
      `/Transactions/company/${companyId}/monthly-total-wages`,

    getWagesWithdrawalsRolloversSummery: (companyId: number) =>
      `/Transactions/company/${companyId}/wages-withdrawals-rollovers`,

    getEmployeeWageWithdrawalsSummery: (companyId: number, year: number, month: number) =>
      `/WageWithdrawals/companies/${companyId}/employees/totals/${year}/${month}`,

    getEmployeeWiseWageWithdrawals: (companyId: number, employeeId: number | string, year: number, month: number) =>
      `/WageWithdrawals/companies/${companyId}/employees/${employeeId}/history/${year}/${month}`,

    // CIXOR Payments Endpoints
    getCIXORPayments: (companyId: number) =>
      `/Transactions/company/${companyId}/payment-history`,

    uploadCixorPaymentPaySlip: () =>
      `/Transactions/upload-cixor-payment-payslip`,

    getCIXORPaymentHistoryByCompanyAndSalaryCycle: (companyId: number, salaryCycleId: number) =>
      `/Transactions/company/${companyId}/salary-cycle/${salaryCycleId}/payment-history`,

    getPaymentHistoryByInvoice: (companyId: number, salaryCycleId: number, invoiceId: number) =>
      `/Transactions/company/${companyId}/salary-cycle/${salaryCycleId}/invoice/${invoiceId}/payment-history`,

    // Pay Day Quick View Endpoints
    getPayDayQuickView: (companyId: number) =>
      `/PayDayQuickView/${companyId}`,

    getPayDayHistoricalData: (companyId: number, salaryCycleId: number) =>
      `/PayDayQuickView/${companyId}/historical/${salaryCycleId}`,

    getLateFeeDetails: (companyId: number) =>
      `/Transactions/company/${companyId}/late-fee-details`,

    // Late Fee Invoice Endpoints (BRP-32)
    lateFeePayNow: (companyId: number, lateFeeId: number) =>
      `/Transactions/company/${companyId}/late-fees/${lateFeeId}/pay-now`,

    lateFeePayLater: (companyId: number, lateFeeId: number) =>
      `/Transactions/company/${companyId}/late-fees/${lateFeeId}/pay-later`,

    uploadLateFeePayslip: () =>
      `/Transactions/upload-late-fee-payslip`,

    getLateFeeInvoiceByCompany: (companyId: number, lateFeeInvoiceId: number) =>
      `/Transactions/company/${companyId}/late-fee-invoices/${lateFeeInvoiceId}`,
    
    downloadLateFeeInvoice: (companyId: number, lateFeeInvoiceId: number) =>
      `/Transactions/company/${companyId}/late-fee-invoice/${lateFeeInvoiceId}/pdf`,

    payCurrentWageWithdrawal: (payload: any) =>
      `/Transactions/company/${payload.companyId}/${payload.invoiceType}/${payload.invoiceContextId}/pay-now`,

    submitPayment: (companyId: number, invoiceId: number) =>
      `/Transactions/company/${companyId}/invoices/${invoiceId}/payment`,

    getCycleBalanceDue: (companyId: number) =>
      `/Transactions/company/${companyId}/cycle-balance-due`,

    // Download Invoice/PDF Endpoints
    downloadInvoicePdf: (companyId: number, salaryCycleId: number, pdfType: InvoicePdfType, invoiceId?: number
    ) => {
      if (pdfType === 'rollover-invoice') {
        return `/Transactions/company/${companyId}/salary-cycle/${salaryCycleId}/rollover-invoice/pdf`;
      }

      return `/Transactions/company/${companyId}/salary-cycle/${salaryCycleId}/eww-total-invoice/${invoiceId}/pdf`;
    },

    //=============================================================================================================//
    // ======================================= Employee's Special Allowance =======================================//
    //=============================================================================================================//
    getEmployeeDetails: (companyId: number) => {
      const params = new URLSearchParams({
        companyId: companyId.toString()
      });
      return `/Employees/names?${params.toString()}`;
    },

    getEmployeeSpecialAllowanceType: (companyId: number) =>
      `/employees/special-allowance-types/company/${companyId.toString()}`,

    requestSpecialAllowanceType: (companyId: number, specialAllowanceDescription: string, requestedBy: number) => {
      const params = new URLSearchParams({
        specialAllowanceDescription,
        requestedBy: requestedBy.toString()
      });

      return `/Companies/${companyId}/special-allowance-type-requests?${params.toString()}`;
    },

    getSpecialAllowanceTypeRequests: (companyId: number) => {
      const params = new URLSearchParams({
        companyId: companyId.toString()
      });
      return `/Companies/special-allowance-type-requests?${params.toString()}`;
    },

    approveOrRejectSpecialAllowaneTypeRequest: (requestId: number, isApproved: boolean, authorizedBy: number) => {
      const params = new URLSearchParams({
        isApproved: isApproved.toString(),
        authorizedBy: authorizedBy.toString()
      });
      return `/Companies/special-allowance-type-requests/${requestId}/approve-or-reject?${params.toString()}`;
    },

    getEmployeeSpecialAllowance: (employeeId: string, companyId: number) => {
      const params = new URLSearchParams({
        employeeId,
        companyId: companyId.toString()
      });
      return `/employees/special-allowances?${params.toString()}`;
    },

    sendForApprovalEmployeeSpecialAllowance: (employeeId: string, companyId: number, specialAllowanceTypeId: number, specialAllowanceAmount: number, requestedBy: number) => {
      const params = new URLSearchParams({
        employeeId,
        companyId: companyId.toString(),
        specialAllowanceTypeId: specialAllowanceTypeId.toString(),
        specialAllowanceAmount: specialAllowanceAmount.toString(),
        requestedBy: requestedBy.toString()
      });
      return `/Employees/special-allowances-request?${params.toString()}`;
    },

    getEmployeeSpecialAllowanceRequests: (companyId: number) => {
      const params = new URLSearchParams({
        companyId: companyId.toString()
      });
      return `/Companies/employee-special-allowance-requests?${params.toString()}`;
    },

    approveOrRejectSpecialAllowaneRequest: (requestId: number, isApproved: boolean, authorizedBy: number) => {
      const params = new URLSearchParams({
        isApproved: isApproved.toString(),
        authorizedBy: authorizedBy.toString()
      });
      return `/Companies/employee-special-allowance-requests/${requestId}/approve-or-reject?${params.toString()}`;
    },

    // ====================== Currently not used methods for update and delete ====================== //
    // updateEmployeeSpecialAllowance: (allowanceId: number, specialAllowanceAmount: number) => {
    //   const params = new URLSearchParams({
    //     specialAllowanceAmount: specialAllowanceAmount.toString()
    //   });
    //   return `/employees/special-allowances/${allowanceId}?${params.toString()}`;
    // },

    // deleteEmployeeSpecialAllowance: (allowanceId: number) =>
    //   `/employees/special-allowances/${allowanceId}`
    //===============================================================================================//

    // ====================== Employee Special Deduction Endpoints ====================== //

    getEmployeeSpecialDeductionType: (companyId: number) =>
      `/employees/special-deduction-types/company/${companyId}`,

    getEmployeeSpecialDeduction: (employeeId: string, companyId: number) => {
      const params = new URLSearchParams({
        employeeId,
        companyId: companyId.toString()
      });
      return `/employees/special-deductions?${params.toString()}`;
    },

    sendForApprovalEmployeeSpecialDeduction: (employeeId: string, companyId: number, specialDeductionTypeId: number, specialDeductionAmount: number, requestedBy: number) => {
      const params = new URLSearchParams({
        employeeId,
        companyId: companyId.toString(),
        specialDeductionTypeId: specialDeductionTypeId.toString(),
        specialDeductionAmount: specialDeductionAmount.toString(),
        requestedBy: requestedBy.toString()
      });
      return `/Employees/special-deductions-request?${params.toString()}`;
    },

    requestSpecialDeductionType: (companyId: number, specialDeductionDescription: string, requestedBy: number) => {
      const params = new URLSearchParams({
        specialDeductionDescription,
        requestedBy: requestedBy.toString()
      });
      return `/Companies/${companyId}/special-deduction-type-requests?${params.toString()}`;
    },

    getSpecialDeductionTypeRequests: (companyId: number) => {
      const params = new URLSearchParams({
        companyId: companyId.toString()
      });
      return `/Companies/special-deduction-type-requests?${params.toString()}`;
    },

    approveOrRejectSpecialDeductionTypeRequest: (requestId: number, isApproved: boolean, authorizedBy: number) => {
      const params = new URLSearchParams({
        isApproved: isApproved.toString(),
        authorizedBy: authorizedBy.toString()
      });
      return `/Companies/special-deduction-type-requests/${requestId}/approve-or-reject?${params.toString()}`;
    },

    getEmployeeSpecialDeductionRequests: (companyId: number) => {
      const params = new URLSearchParams({
        companyId: companyId.toString()
      });
      return `/Companies/employee-special-deduction-requests?${params.toString()}`;
    },

    approveOrRejectSpecialDeductionRequest: (requestId: number, isApproved: boolean, authorizedBy: number) => {
      const params = new URLSearchParams({
        isApproved: isApproved.toString(),
        authorizedBy: authorizedBy.toString()
      });
      return `/Companies/employee-special-deduction-requests/${requestId}/approve-or-reject?${params.toString()}`;
    },

    //================================================================================//

  };

  // Payroll Dashboard
  static getPayrollSummary = (companyId: string) =>
    `/Companies/${companyId}/payroll-summary`;

  // Department Request Endpoints
  static department = {
    insert: (companyId: number, departmentName: string, requestedBy: number, description?: string) => {
      const params = new URLSearchParams({
        departmentName,
        requestedBy: requestedBy.toString(),
        ...(description ? { description } : {})
      });
      return `/Companies/${companyId}/department-requests?${params.toString()}`;
    },

    getAll: (companyId: number, departmentId?: number) => {
      if (departmentId !== undefined && departmentId !== null) {
        return `/Companies/${companyId}/department-requests?departmentId=${departmentId}`;
      }
      return `/Companies/${companyId}/department-requests`;
    },

    update: (companyId: number, departmentId: number, departmentName: string, modifiedRequestedBy: number, description?: string) => {
      const params = new URLSearchParams({
        departmentName,
        modifiedRequestedBy: modifiedRequestedBy.toString(),
        ...(description ? { description } : {})
      });
      return `/Companies/${companyId}/department-requests/${departmentId}?${params.toString()}`;
    },

    delete: (companyId: number, departmentId: number, deleteRequestedBy: number) => {
      const params = new URLSearchParams({
        deleteRequestedBy: deleteRequestedBy.toString()
      });
      return `/Companies/${companyId}/department-requests/${departmentId}?${params.toString()}`;
    },
  };

  // Company Document Templates
  static getDocumentTemplate = (documentType: string) =>
    `/Companies/document-templates/${documentType}`;

  // Payroll Invoice
  static getPayrollInvoiceDetails = (companyId: number) =>
    `/Companies/${companyId}/payroll-invoice-details`;

  static downloadPayrollInvoiceReport = (invoiceReportBlobUrl: string) =>
    `/Companies/payroll-invoice-report/download?invoiceReportBlobUrl=${encodeURIComponent(invoiceReportBlobUrl)}`;

  static uploadPayslip = (companyId: number) =>
    `/Companies/${companyId}/payslip/upload`;

  static submitPayrollInvoice = () =>
    `/Companies/submit-payroll-invoice`;

  // Notifications Endpoints
  static notifications = {
    getAll: (params: Record<string, string | number | boolean>) => {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          query.set(key, String(value));
        }
      });
      const qs = query.toString();
      return `/notifications${qs ? '?' + qs : ''}`;
    },

    getUnreadCount: (channel?: string) => {
      if (channel) {
        return `/notifications/unread-count?channel=${encodeURIComponent(channel)}`;
      }
      return `/notifications/unread-count`;
    },

    markAsRead: (id: number) => `/notifications/${id}/read`,

    clear: (id: number) => `/notifications/${id}/clear`,

    readAll: (channel?: string) => {
      if (channel) {
        return `/notifications/read-all?channel=${encodeURIComponent(channel)}`;
      }
      return `/notifications/read-all`;
    },

    clearAll: (channel?: string) => {
      if (channel) {
        return `/notifications/clear-all?channel=${encodeURIComponent(channel)}`;
      }
      return `/notifications/clear-all`;
    },
  };

  // HR Support Conversations (admin side) -- Added by Akila on 26/6/25
  static supportConversations = {
    list: (params: Record<string, string | number | boolean>) => {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          query.set(key, String(value));
        }
      });
      const qs = query.toString();
      return `/SupportConversations/company${qs ? '?' + qs : ''}`;
    },

    employeeInbox: (params: Record<string, string | number | boolean>) => {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          query.set(key, String(value));
        }
      });
      const qs = query.toString();
      return `/SupportConversations/company/employees${qs ? '?' + qs : ''}`;
    },

    employeeConversations: (employeeId: string, params: Record<string, string | number | boolean>) => {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          query.set(key, String(value));
        }
      });
      const qs = query.toString();
      return `/SupportConversations/company/employees/${encodeURIComponent(employeeId)}${qs ? '?' + qs : ''}`;
    },

    messages: (id: number, companyId: number) =>
      `/SupportConversations/${id}/messages?companyId=${companyId}`,

    sendMessage: (id: number, companyId: number) =>
      `/SupportConversations/${id}/messages?companyId=${companyId}`,

    updateStatus: (id: number, companyId: number) =>
      `/SupportConversations/${id}/status?companyId=${companyId}`,

    markSeen: (id: number, companyId: number) =>
      `/SupportConversations/${id}/seen?viewerType=Admin&companyId=${companyId}`,

    attachment: (messageId: number, companyId: number) =>
      `/SupportConversations/messages/${messageId}/attachment?companyId=${companyId}`,
  };
}
